import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { RealizationStep } from "web_myplann/Goals/Hooks/useRealizationContent";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	step: RealizationStep;
	accent: string;
};

export const RealizationStepRow: FC<Props> = ({ step, accent }) => {
	const theme = useTheme();
	const Icon = step.icon;

	return (
		<Stack direction="row" alignItems="center" gap={1.5}>
			<IconBox bg={theme.hero.tileBg} size={36}>
				<Icon size={theme.iconSize.sm} color={accent} />
			</IconBox>
			<Stack flex={1} minWidth={0}>
				<Typography variant="caption" fontWeight={600}>
					{step.title}
				</Typography>
				<Typography variant="caption" color={theme.palette.grey[500]}>
					{step.subtitle}
				</Typography>
			</Stack>
		</Stack>
	);
};
